import { render, staticRenderFns } from "./Facets.vue?vue&type=template&id=9d81c9f0"
import script from "./Facets.vue?vue&type=script&lang=js"
export * from "./Facets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports